// extracted by mini-css-extract-plugin
module.exports = {"triangle-down":"error-tip_triangle-down__PBIIK"};